<template>
  <v-app class="no_min_height">
    <div class="container font_martel">
      <div class="d-md-block d-sm-block d-none">
        <img
          src="/front/images/login/Zoopup-logo.png"
          alt="Description of Image"
          class="my-image"
          height="84"
        />
      </div>

      <h2 class="mt-4 head_title font-weight-black">Finish signing up as {{ user_type }}</h2>
      <p class="mt-4 subtitle">
        Choose the area you'd like to delve into first. You can always switch between roles as you
        go along.
      </p>

      <!-- Form Fields Start Here -->
      <v-card>
        <v-form class="form_style" @submit.prevent="readData()">
          <!-- Legal Name Field -->
          <div class="mb-0" id="signupform">
            <template>
              <div>
                <label class="custom_subheading_info text-body-color">Legal Name</label>
                <div class="tooltip-wrapper">
                  <!-- Text Field -->
                  <v-text-field
                    ref="nameField"
                    @focus="scroll('signupform')"
                    class="mb-4 custom_input_field mt-n4"
                    type="text"
                    solo
                    v-model="user_fullname"
                    :error-messages="
                      $v.user_fullname.$error
                        ? !$v.user_fullname.required
                          ? 'Required!'
                          : $v.user_fullname.$invalid
                            ? 'Name is invalid!'
                            : !$v.user_fullname.minLength
                              ? 'Minimum Length 4'
                              : ''
                        : ''
                    "
                    placeholder="eg. John Doe"
                  >
                  </v-text-field>

                  <!-- Tooltip Component (Only Visible on Desktop) -->
                  <v-tooltip v-if="isDesktop" right :activator="nameFieldActivator">
                    <template v-slot:default>
                      <div class="tooltip-content">
                        <v-row class="align-center tooltip-header">
                          <v-col cols="2" class="justify-center d-flex">
                            <v-icon class="tooltip-icon" color="yellow" large
                              >mdi-lightbulb-on</v-icon
                            >
                          </v-col>
                          <v-col cols="10">
                            <span class="mt-3 name_tooltip default-font">Full Name</span>
                          </v-col>
                        </v-row>
                        <div class="mt-3 tooltip-text">
                          Make sure this matches the name on your government-issued ID. If you go by
                          another name, you can add a
                          <a href="#" class="tooltip-link">preferred first name</a>.
                        </div>
                      </div>
                    </template>
                  </v-tooltip>
                </div>
              </div>
            </template>
          </div>
          <span class="d-md-none d-sm-none d-block mt-n7">
            <p class="text-body-color font-10 text-start">
              Make sure this matches the name on your government-issued ID. If you go by another
              name, you can add a <strong>preferred first name</strong>.
            </p>
          </span>

          <!-- Email Field -->
          <label class="custom_subheading_info text-body-color">Email Address</label>

          <div class="tooltip-wrapper">
            <v-text-field
              ref="emailField"
              class="mb-4 custom_input_field mt-n4"
              type="text"
              solo
              autocomplete="false"
              v-model="$v.user_email.$model"
              @blur="emailvalidnew()"
              @focus="((existEmail = ''), scroll('signupform'))"
              :error-messages="
                $v.user_email.$error
                  ? !$v.user_email.required
                    ? 'Required!'
                    : 'Please enter a valid email !'
                  : existEmail
              "
              placeholder="eg. name@company.com"
              :append-icon="buttontrigger ? 'mt-3 fa fa-spinner fa-spin' : ''"
              v-bind="attrs"
              v-on="on"
            >
            </v-text-field>
            <v-tooltip v-if="isDesktop" right :activator="emailFieldActivator">
              <template v-slot:default>
                <div class="tooltip-content">
                  <v-row class="align-center tooltip-header">
                    <v-col cols="2" class="justify-center d-flex">
                      <v-icon class="tooltip-icon" color="yellow" large>mdi-lightbulb-on</v-icon>
                    </v-col>
                    <v-col cols="10">
                      <span class="mt-3 name_tooltip default-font">Email</span>
                    </v-col>
                  </v-row>

                  <div class="mt-3 tooltip-text">
                    We'll email you a verification email for confirmation
                  </div>
                </div>
              </template>
            </v-tooltip>
          </div>
          <span class="d-md-none d-sm-none d-block mt-n7">
            <p class="text-body-color font-10 text-start">
              We’ll email you a verification link for confirmation.
            </p>
          </span>

          <!-- Password Field with Toggle Visibility -->
          <label class="custom_subheading_info text-body-color">Password</label>

          <v-text-field
            ref="passwordField"
            class="mb-2 custom_input_field mt-n4"
            @focus="scroll('signupform')"
            :type="showPass ? 'text' : 'password'"
            placeholder="••••••••"
            solo
            autocomplete="new-password"
            name="password"
            v-bind="attrs"
            v-on="on"
            v-model="$v.user_password.$model"
            :error-messages="
              $v.user_password.$error
                ? [
                    !$v.user_password.required ? 'Required!' : '',
                    !$v.user_password.minLength ? 'Need at least 8 characters' : '',
                    !$v.user_password.hasUppercase ? 'Need at least one uppercase letter' : '',
                    !$v.user_password.hasLowercase ? 'Need at least one lowercase letter' : '',
                    !$v.user_password.hasNumber ? 'Need at least one number' : '',
                    !$v.user_password.hasSpecialChar ? 'Need at least one special character' : '',
                  ].filter(Boolean)
                : []
            "
          >
            <template v-slot:append>
              <a @click="showPass = !showPass" tabindex="-1">
                <i v-if="showPass" class="mt-1 fa fa-eye"></i>
                <i v-else class="mt-1 fa fa-eye-slash"></i>
              </a>
            </template>
            <template v-slot:prepend-inner> </template>
          </v-text-field>

          <v-tooltip v-if="isDesktop" right :activator="passwordFieldActivator">
            <template v-slot:default>
              <div class="tooltip-content">
                <v-row class="align-center tooltip-header">
                  <v-col cols="2" class="justify-center d-flex">
                    <v-icon class="tooltip-icon" color="yellow" large>mdi-lightbulb-on</v-icon>
                  </v-col>
                  <v-col cols="10">
                    <span class="mt-3 name_tooltip default-font">Password</span>
                  </v-col>
                </v-row>
                <div class="mt-3 tooltip-text">
                  <ul>
                    <li>Needs atleast one symbol or number</li>
                    <li>Needs atleast 8 characters</li>
                  </ul>
                </div>
              </div>
            </template>
          </v-tooltip>

          <template v-slot:prepend-inner>
            <v-tooltip
              top
              v-if="$v.user_password.$error"
              max-width="250"
              color="white"
              :style="{ 'max-width': '10px' }"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="" color="red" dark v-bind="attrs" v-on="on">
                  mdi-information
                </v-icon>
              </template>
              <span class="text-danger">
                Password Strength: Weak. Ensure your password contains at least:
                <ul>
                  <li>8 characters</li>
                  <li>1 uppercase letter</li>
                  <li>1 lowercase letter</li>
                  <li>1 number</li>
                  <li>1 special character</li>
                </ul>
              </span>
            </v-tooltip>
            <span v-else>
              <v-icon>mdi-lock</v-icon>
            </span>
          </template>

          <!-- Terms Checkbox -->
          <div class="row align-items-center mt-md-0 mt-n7">
            <div class="ml-3 d-flex align-items-center">
              <v-checkbox v-model="agreed" class="me-2" style="margin-top: -47px"></v-checkbox>
              <label
                class="pt-5 form-check-label font-text text-start checked_text"
                for="flexCheckChecked"
              >
                By checking this box, you agree to Zoopup’s
                <strong>
                  <a href="/term" target="_blank">
                    <span class="text_guide_color"
                      >Terms of Service, Payments Terms of Service</span
                    >
                  </a>
                </strong>
                and
                <strong>
                  <a href="/term" target="_blank">
                    <span class="text_guide_color">and Anti-Discrimination Policy,</span>
                  </a>
                </strong>
                and acknowledge the
                <strong>
                  <a href="/privacy" target="_blank">
                    <span class="text_guide_color"> Privacy Policy.</span>
                  </a>
                </strong>
                You also acknowledge that you have read and understood our Privacy Policy.
              </label>
            </div>
          </div>

          <!-- Proceed Button -->
          <button class="btn proceed-button" :disabled="!agreed" type="submit">Proceed</button>
        </v-form>
      </v-card>
    </div>

    <v-divider :thickness="1" color="grey" dark horizontal class="mx-5 my-4"></v-divider>

    <!-- Footer Links -->
    <div class="my-4 ml-5 footer text-start text-uppercase">
      <a class="footer_style" href="#">Terms of Use</a> •
      <a class="footer_style" href="#">Privacy Policy</a> •
      <a class="footer_style" href="#">Contact</a>
    </div>

    <vue-recaptcha
      v-if="captchaShow"
      ref="recaptcha"
      @verify="onCaptchaVerified"
      @expired="onCaptchaExpired"
      size="invisible"
      sitekey="6Le5H_0cAAAAAEOHJNHxDCE0PYJhJ8dOwzVbcdHy"
    >
    </vue-recaptcha>
  </v-app>
</template>

<script>
import { required, minLength, between, email, helpers } from 'vuelidate/lib/validators';

import DataService from '../../../dataservice';

import VueRecaptcha from 'vue-recaptcha';
export default {
  components: {
    // "form-error": FormError,
    VueRecaptcha,
  },
  data() {
    return {
      form: {
        recaptcha: '',
      },
      showPassword: false,
      agreed: false,
      termsText: `By checking this box, you agree to Zoopup's Terms of Service, Payments Terms of Service and Anti-Discrimination Policy, and acknowledge the Privacy Policy. You also acknowledge that you have read and understood our Privacy Policy.`,
      user_mobile: localStorage.getItem('userMobile'),
      country_code: localStorage.getItem('userCountryCode'),
      user_type: localStorage.getItem('userType'),
      source: localStorage.getItem('source'),
      keywords: localStorage.getItem('keywords'),
      campaign: localStorage.getItem('campaign'),
      adname: localStorage.getItem('adname'),
      user_email: '',
      user_fullname: '',
      user_password: null,
      existEmail: '',
      emPass: false,
      buttontrigger: false,
      checkbox_value: true,
      captchaShow: false,
      processing: false,
      errors: {},
      validateCaptcha: false,
      showPass: false,
      nameFieldActivator: null,
      emailFieldActivator: null,
      passwordFieldActivator: null,
      isDesktop: window.innerWidth >= 768,
      type: 'step_two',
    };
  },

  mounted() {
    this.$nextTick(() => {
      if (this.$refs.nameField) {
        this.nameFieldActivator = this.$refs.nameField.$el;
      }
      if (this.$refs.emailField) {
        this.emailFieldActivator = this.$refs.emailField.$el;
      }
      if (this.$refs.passwordField) {
        this.passwordFieldActivator = this.$refs.passwordField.$el;
      }
    });
    window.addEventListener('resize', this.checkScreenSize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize);
  },
  validations() {
    return {
      user_fullname: {
        required,
        minLength: minLength(4),
        passReg: helpers.regex('alpha', /^[A-Za-z\s]+$/),
      },
      user_password: {
        required,
        minLength: minLength(8),
        hasUppercase: helpers.regex('hasUppercase', /(?=.*?[A-Z])/),
        hasLowercase: helpers.regex('hasLowercase', /(?=.*?[a-z])/),
        hasNumber: helpers.regex('hasNumber', /(?=.*?[0-9])/),
        hasSpecialChar: helpers.regex('hasSpecialChar', /(?=.*?[\W])/),
      },
      user_email: { required, email },
    };
  },
  methods: {
    resetForm() {
      // Reset all form fields
      this.user_fullname = '';
      this.user_email = '';
      this.user_password = '';
      this.user_type = '';
      this.user_mobile = '';
      this.country_code = '';
      // Reset validation states
      this.$v.$reset();
    },
    onCaptchaExpired: function () {
      this.$refs.recaptcha.reset();
    },
    onCaptchaVerified: function (recaptchaToken) {
      console.log('abc');
      this.$refs.recaptcha.reset();
      let loader = this.$loading.show({
        container: this.$refs.formContainer,
        canCancel: false,
        color: '#007BFF',
      });
      this.showDataTable = true;
      const data = new FormData();
      data.append('user_email', this.user_email);
      data.append('user_password', this.user_password);
      data.append('user_fullname', this.user_fullname);
      data.append('user_phone', `${this.country_code}${this.user_mobile}`);
      data.append('country_code', this.country_code);
      data.append('user_type', this.user_type);
      data.append('user_token', recaptchaToken);
      data.append('source', this.source);
      data.append('keywords', this.keywords);
      data.append('campaign', this.campaign);
      data.append('adname', this.adname);
      DataService.registeruseronsignup(data)
        .then(response => {
          // console.log(response);
          if (response.data.error) {
            this.existEmail = response.data.error.user_email ? response.data.error.user_email : '';
          }
          // console.log(response, "comming data");
          if (response.data.status == 'success') {
            this.resetForm();

            localStorage.removeItem('source');
            localStorage.removeItem('keywords');
            localStorage.removeItem('campaign');
            localStorage.removeItem('adname');

            window.location.replace('/user/created');
          }
          if (response.data.status == 'not_valid') {
            this.existEmail = 'Enter a Valid Email';
          }
          loader.hide();
        })
        .catch(e => {
          // console.log(e);
          loader.hide();
        });
    },
    scroll(el) {
      document.getElementById(el).scrollIntoView({ behavior: 'smooth' });
    },
    readData() {
      this.$v.$touch();
      console.log('abbcbbb');
      console.log(this.$v);
      console.log(this.emPass);
      if (this.$v.$error || this.existEmail) {
        return;
      }
      if (this.emPass) {
        this.$refs.recaptcha.execute();
      }
      // window.location.replace("/user/created");
    },
    checkScreenSize() {
      this.isDesktop = window.innerWidth >= 768; // Update state on resize
    },
    emailvalidnew() {
      this.$v.user_email.$touch();
      if (this.$v.user_email.$error) return;
      this.buttontrigger = true;
      DataService.emailvalid({ user_email: this.user_email })
        .then(response => {
          // console.log(response);
          if (response.data.error) {
            this.existEmail = response.data.error.user_email ? response.data.error.user_email : '';
            this.emPass = false;
          } else if (response.data.status == 'not_valid') {
            this.existEmail = 'Enter a Valid Email';
            this.emPass = false;
          } else {
            if (response.data.status == 'success') {
              this.captchaShow = true;
              this.emPass = true;
            }
            this.existEmail = '';
            // console.log('valid');
          }
          this.buttontrigger = false;
        })
        .catch(error => {
          this.buttontrigger = false;
        });
    },
    // Toggle password visibility
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    // Method to handle proceed action
    proceed() {
      this.$router.push({ name: 'userscreated' });
    },
  },
  watch: {
    type() {
      if (this.type == 'step_two') this.captchaShow = true;
    },
  },
  computed: {
    isLoggedIn: function () {
      if (typeof this.$parent.$attrs.user === 'undefined') return false;
      else return true;
    },
    isAdmin: function () {
      if (typeof this.$parent.$attrs.user === 'undefined') return false;
      else if (this.$parent.$attrs.user.user_type === 'Admin') return true;
      else return false;
    },
    url() {
      return this.user_type === 'Freelancer'
        ? 'https://zoopup.com/oauth_google_freelancer/'
        : 'https://zoopup.com/oauth_google_client/';
    },
  },
};
</script>

<style src="../../../../assets/css/clientPage.css"></style>

<style scoped>
@import '../../../../css/otp.css';
@import '../../../../css/loginnew.css';
@import url('https://fonts.googleapis.com/css2?family=Martel+Sans:wght@400;500;600;700;800;900&display=swap');

.text-body-color {
  color: #455065 !important;
}

:deep(.v-application--wrap) {
  background-color: #ffffff !important;
}
.checked_text {
  font-size: 14px;
  margin-left: 0px;
}

.default-font {
  font-family: 'Poppins', sans-serif !important;
}

.name_tooltip {
  display: block;
  font-weight: 500;
  font-size: 28px;
  color: #353535;
}

.tooltip-wrapper {
  display: flex;
  align-items: center;
  position: relative;
}

.v-tooltip__content {
  background: #ffffff !important;
  color: #7b7b7b !important;
  border-radius: 6px !important;
  padding: 24px !important;
  border-radius: 12px !important;
  font-size: 14px !important;
  max-width: 300px !important;
  width: auto !important;
  height: auto !important;
  box-shadow: -8px 4px 10px rgba(0, 0, 0, 0.5) !important;
  text-align: left;
  margin-left: 18px;
  white-space: normal !important;
  word-wrap: break-word !important;
}

.v-tooltip__content::before {
  content: '';
  position: absolute;
  top: 50%;
  left: -18px;
  transform: translateY(-50%);
  width: 18px;
  height: 36px;
  background: #ffffff;
  clip-path: polygon(0 50%, 100% 0, 100% 100%);
  box-shadow: -2px 2px 6px rgba(0, 2, 0, 0.4);
}

.tooltip-link {
  color: #7b7b7b;
  text-decoration: underline;
  font-weight: bold;
}

.font-10 {
  font-size: 10px;
}

.custom_subheading_info {
  font-weight: 700;
  font-size: 20px;
  font-family: 'Martel Sans';
  text-align: start;
  width: 100%;
  display: inline-block;
}

.form_style {
  padding: 150px;
  margin-left: 10px;
  margin-top: -155px;
}

.custom_input_field .v-input__slot {
  box-shadow: none !important;
  border: 3px solid #e7e8e9 !important;
}

.custom_input_field.error--text .v-input__slot {
  border: 3px solid #ff5252 !important;
}

.proceed-button {
  background-color: #1569b2;
  color: #ffffff;
  padding: 14px 221px;
  margin-top: 75px;
  margin-left: 40px;
  border: none;
  border-radius: 5px;
  font-weight: 600;
  cursor: pointer;
}

.footer {
  margin-bottom: -50px;
  margin-top: 30px;
  font-weight: 900;
  font-size: 12px;
}

.footer_style {
  color: #606060;
  margin: 0 5px;
  text-decoration: none;
}

.font_martel {
  font-family: 'Martel Sans' !important;
}

.container {
  text-align: center;
  padding: 2rem;
}

.head_title {
  font-size: 32px !important;
  font-family: 'Martel Sans' !important;
}

.subtitle {
  color: #666;
  margin-bottom: 2rem;
  font-size: 18px;
}

.proceed {
  margin-top: 90px;
  padding: 16px 220px !important;
}

.v-card {
  width: 844px;
  height: 706px;
  margin-left: 144px;
  padding-top: 40px;
}

@media only screen and (min-width: 355px) and (max-width: 380px) {
  .checked_text {
    font-size: 11px;
    margin-left: -9px;
  }
  .proceed-button {
    padding: 14px 113px !important;
    margin-left: 0px;
    margin-top: 57px;
  }
  .custom_subheading_info {
    font-size: 14px !important;
  }

  .head_title {
    text-align: start;
    font-size: 20px !important;
  }

  .subtitle {
    text-align: start;
    font-size: 14px !important;
  }

  .form_style {
    padding: 0px !important;
    margin-left: 0px !important;
    margin-top: 0px !important;
  }
  .v-card {
    width: 844px;
    height: 706px;
    margin-left: 0px;
    padding: 40px 10px 0px 10px;
  }
}
@media only screen and (min-width: 381px) and (max-width: 800px) {
  .checked_text {
    font-size: 11px;
    margin-left: -9px;
  }
  .custom_subheading_info {
    font-size: 14px !important;
  }

  .head_title {
    text-align: start;
    font-size: 20px !important;
  }

  .subtitle {
    text-align: start;
    font-size: 14px !important;
  }
  .proceed-button {
    padding: 14px 126px !important;
    margin-left: 0px;
  }

  .form_style {
    padding: 0px !important;
    margin-left: 0px !important;
    margin-top: 0px !important;
  }
  .v-card {
    width: 844px;
    height: 706px;
    margin-left: 0px;
    padding: 40px 10px 0px 10px;
  }
}
</style>
